// extracted by mini-css-extract-plugin
export default {"button":"PrimaryBannerLayout_button__d2N-h"};